<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
    components: {
        TheSidebar,
        TheHeader,
        TheFooter,
	},
    mounted(){
        if(this.$store.state.perms.can_view_monitoring_page == true
            && this.$store.state.get_chart == false){
			this.get_chart();
			this.$store.commit('set_get_chart');
        }
        if(this.$store.state.perms.can_view_user_send_rcv_into_data
            || this.$store.state.perms.can_view_same_group_user_send_rcv_into_data
            || this.$store.state.perms.can_view_all_user_send_rcv_into_data_for_all_users
            || this.$store.state.perms.can_view_user_logs_over_ws
            || this.$store.state.perms.can_view_same_user_groups_logs_over_ws
            || this.$store.state.perms.can_view_all_user_logs_over_ws){
            this.websocket();
        }
    },
	methods: {
		get_chart(){
            this.axios.get('get_time')
                .then(res => {
                    const today = res.data.current_date.split(' ');
                    this.axios.get('send_rcv_info/'
                        + '?created_at=' + today[0]
                        + '&user_id=' + this.$store.state.u_id
                        + '&limit=20'
                        + '&offset=1')
                        .then(res => {
                            res.data.map(val => {
                                this.$store.commit('rest_send_sms_count', val.send_sms_count);
                                this.$store.commit('rest_rcv_sms_count', val.rcv_sms_count);
                                this.$store.commit('rest_in_queue_sms_count', val.in_queue_sms_count);
                                let created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD').split(' ');
                                this.$store.commit('rest_created_at', created_at[0]);
                            });
                        })
                }) 
        },
		websocket(){
            if(this.$store.state.connect == false){
                this.$store.commit('socket_connect');
                this.$store.commit('set_connect', true);
            }
            this.$store.state.socket.onclose = () => {
                if(this.$store.state.on_close){
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        text: 'خطا! اتصال به سرور قطع شد.'
                    });
                }
                if(this.$store.state.on_open == false){
                    this.$store.commit('set_on_open', true);
                }
                this.$store.state.socket = new WebSocket("ws://idehgate.ir/ws", this.$store.state.token.slice(7));
            }
            this.$store.state.socket.onopen = () => {
                if(this.$store.state.on_open){
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        text: 'اتصال به سرور برقرار شد.'
                    });
                }
            }
            this.$store.state.socket.onmessage = (event) => {
                let store = JSON.parse(event.data);
                if(store.message_type == 'monitoring_chart'){
                    if(store.message_info.user_id == this.$store.state.u_id){
                        if(this.$store.state.perms.can_view_user_send_rcv_into_data
                            || this.$store.state.perms.can_view_same_group_user_send_rcv_into_data
                            || this.$store.state.perms.can_view_all_user_send_rcv_into_data_for_all_users){
                            this.$store.commit('socket_send_sms_count', store.message_info.send_sms_count);
                            this.$store.commit('socket_rcv_sms_count', store.message_info.rcv_sms_count);
                            this.$store.commit('socket_in_queue_sms_count', store.message_info.in_queue_sms_count);
                            let created_at = this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD').split(' ');
                            this.$store.commit('socket_created_at', created_at[0]);
                        }
                    }
                }
                else if(store.message_type == 'system_logs'){
                    if(this.$store.state.perms.can_view_user_logs_over_ws
                        || this.$store.state.perms.can_view_same_user_groups_logs_over_ws
                        || this.$store.state.perms.can_view_all_user_logs_over_ws){
                        if(store.message_info.to_id == this.$store.state.u_id){
                            if(store.message_info.from_id == 0 && store.message_info.to_id == 0){
                                if(this.$store.state.perms.can_view_system_logs_over_ws){
                                    this.$store.commit('set_notifications', {
                                        from_name: store.message_info.from_user_info.name,
                                        to_name: store.message_info.to_user_info.name,
                                        ip: store.message_info.log_info.remote_info.remote_ip,
                                        log_type: store.message_info.log_info.log_string,
                                        created_at: this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD')
                                    }); 
                                }
                            }
                            else if(store.message_info.from_id == 0 && store.message_info.to_id == this.$store.state.u_id){
                                if(this.$store.state.perms.can_view_system_logs_over_ws){
                                    this.$store.commit('set_notifications', {
                                        from_name: store.message_info.from_user_info.name,
                                        to_name: store.message_info.to_user_info.name,
                                        ip: store.message_info.log_info.remote_info.remote_ip,
                                        log_type: store.message_info.log_info.log_string,
                                        created_at: this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD')
                                    }); 
                                }
                            }
                            else if(store.message_info.from_id == this.$store.state.u_id && store.message_info.to_id == 0){
                                this.$store.commit('set_notifications', {
                                    from_name: store.message_info.from_user_info.name,
                                    to_name: store.message_info.to_user_info.name,
                                    ip: store.message_info.log_info.remote_info.remote_ip,
                                    log_type: store.message_info.log_info.log_string,
                                    created_at: this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD')
                                });
                            }
                            else if(store.message_info.from_id == this.$store.state.u_id){
                                this.$store.commit('set_notifications', {
                                    from_name: store.message_info.from_user_info.name,
                                    to_name: store.message_info.to_user_info.name,
                                    ip: store.message_info.log_info.remote_info.remote_ip,
                                    log_type: store.message_info.log_info.log_string,
                                    created_at: this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD')
                                });
                            }
                            else if(store.message_info.to_id == this.$store.state.u_id){
                                this.$store.commit('set_notifications', {
                                    from_name: store.message_info.from_user_info.name,
                                    to_name: store.message_info.to_user_info.name,
                                    ip: store.message_info.log_info.remote_info.remote_ip,
                                    log_type: store.message_info.log_info.log_string,
                                    created_at: this.$moment(store.message_info.created_at, 'YYYY-MM-DD HH:mm').locale('fa').format('HH:mm jYYYY/jMM/jDD')
                                });
                            }                            
                        }
                    }
                }
            }
        },
    },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>